goog.provide('el8.uiwidget.NewActionsMenu');

goog.require('el8.template.uiwidget.NewActionsMenu');
goog.require('el8.uiwidget.alert');
goog.require('el8.uid');

/**
 * Dropdown menus with actions related to a particular item
 *
 * If you're adding / updating actions for an existing actions menu context,
 * it's pretty simple. display() takes a list of actions and you
 * just need to add a new dict to that list. See, e.g., feedItemActions.js
 *
 * If you're creating a new actions menu in a new context, the hardest
 * part about this widget is figuring out what to set `container`
 * and `anchorTop` to make it work right / make the positioning coherent.
 * `container` should generally point to the scrollable container
 * surrounding the click target. `anchorTop` can sometimes point to the same
 * element (see, e.g., problemHx.js) or it can point to the non-scrollable
 * parent inside in `container` (see, e.g., visitNote/main.js).
 *
 * This thing is definitely a candidate for being rewritten because I can't explain
 * how to make it work reliably in any more detail than that... it always
 * involves some trial and error a
 *
 * Also see the note at the top of display() about returning false after invoking
 * that function.
 */
(function() {
    var _allMenus = [];
    function hideAllMenus() {
        for (var i=0; i<_allMenus.length; i++) {
            _allMenus[i].hide();
        }
    }

    el8.uiwidget.NewActionsMenu = function(opts) {
        this._id = el8.uid.getUid(this);
        this._container = opts.container;
        this._anchorTop = opts.anchorTop;
        this._width = opts.width || 168;
        this._menuId = opts.menuId || null;
        this._twoColumn = opts.twoColumn || null;
        this._isAlignRight = true; // assume always true for now

        this._defaultOffsets = {top: 0, left: 0};
        if (opts.offsets) {
            if (opts.offsets.top !==undefined) { this._defaultOffsets.top = opts.offsets.top; }
            if (opts.offsets.left !==undefined) { this._defaultOffsets.left = opts.offsets.left; }
        }

        this._currActionsList = null;
        this._currHighlighted = null;

        // TODO Uniformize this
        this._doHighlight = (opts.doHighlight !== false); // default true
        this._highlightClass = opts.highlightClass || 'el8ItemSelected';
        this._highlightClassList = opts.highlightClassList || null;
        this._highlightList = [
            'am-highlight',
            'actions-trigger',
            'topActionContainer',
            'feedItem',
            'overlayFeedItem',
            'itemAction',
            'actionsTrigger',
            'menuTrigger',
            'item',
            'itemBullet',
            'le-entry',
            'editTrigger'
        ];

        this._isInit = false;
        this._init(); // Do initialization up front
    };

    el8.uiwidget.NewActionsMenu.prototype.setAnchorTop = function(anchorTop) {
        this._anchorTop = anchorTop;
    };

    el8.uiwidget.NewActionsMenu.prototype.setWidth = function(width) {
        this._width = width;
    };

    el8.uiwidget.NewActionsMenu.prototype._init = function() {
        if (this._isInit) { return; }
        _allMenus.push(this);

        if (this._twoColumn) {
            this._container.append(el8.template.uiwidget.NewActionsMenu.contentTwoColumn({
                menuId: this._menuId
            }));
        } else {
            this._container.append(el8.template.uiwidget.NewActionsMenu.content({
                menuId: this._menuId
            }));
        }

        if (!/^(absolute|fixed|relative)$/.test(this._container.css('position'))) {
            this._container.css('position', 'relative');
        }

        // _menuContainer might have more than one '.am-container', find the right one
        this._menuContainer = $('#'+this._menuId, this._container);

        if (this._width) { this._menuContainer.outerWidth(this._width); }

        if (this._twoColumn) {
            this._menuListRight = $('.am-list-right', this._container);
            this._menuListLeft = $('.am-list-left', this._container);
        } else {
            this._menuList = $('.am-list', this._container);
        }

        var that = this;
        var modalFn = function(event) {
            if (!$(event.target).closest('.am-container').length) {
                that.hide();
            }
            return false;
        };

        this._menuContainer.jqm({
            modal: false,
            overlay: 0,
            onHide: function(hash) {
                if (that._twoColumn) {
                    that._menuListRight.empty();
                    that._menuListLeft.empty();
                } else {
                    that._menuList.empty();
                }
                hash.w.hide();
                if (hash.o) { hash.o.remove(); }
                if (that._currHighlighted) {
                    if (that._highlightClassList) {
                        that._highlightClassList.map(function(a) {
                            that._currHighlighted.removeClass(a);
                        });
                    } else {
                        that._currHighlighted.removeClass(that._highlightClass);
                    }
                }
                $(document).unbind('click', modalFn);
            },
            onShow: function(hash) {
                // display the overlay (prepend to body) if not disabled
                if(hash.c.overlay) { hash.o.prependTo('body'); }

                hash.w.show();

                $(document).on('click', modalFn);
            }
        });

        this._container.on('click', '#'+this._menuId, function(event) {
            var $actionItem = $(event.target).closest('li[actionIndex]');
            var actionIndex = parseInt($actionItem.attr('actionIndex'), 10);
            if (that._currActionsList.length > actionIndex) {
                if (that._currActionsList[actionIndex]['actionFn']) {
                    that._currActionsList[actionIndex]['actionFn'](that._currItem, $actionItem);
                } else {
                    el8.uiwidget.alert("This functionality has not been implemented yet.");
                }
                that.hide();
            }
            return false;
        });

        this._isInit = true;
    };

    el8.uiwidget.NewActionsMenu.prototype.display = function($target, item, offsets, actionsList, zIndex, highlightClass) {

        // NOTE: It is VERY IMPORTANT to return false right after
        // this function is called in the external method calling
        // this.  Otherwise, menu gets hidden right away and causes
        // a lot of confusion!

        // NOTE: highlightClass MUST be one of the classes widget was initialized
        // with in options.highlightClassList

        this._currActionsList = actionsList || [];

        // Do nothing if no actions list to show
        if (!this._currActionsList.length) { return; }

        if (!this._isInit) { this._init(); }

        // First, hide all menus
        hideAllMenus();

        this._currItem = item;

        if (this._doHighlight) {
            var result = $target.el8_closestWithAnyClass(this._highlightList);
            if (result.length) {
                this._currHighlighted = $(result[0]);
                this._currHighlighted.addClass(highlightClass || this._highlightClass);
            } else {
                this._currHighlighted = null;
            }
        }

        if (this._twoColumn) {
            this._menuListRight.append(el8.template.uiwidget.NewActionsMenu.actions({
                actionsList: actionsList,
                right: true
            }));
            this._menuListLeft.append(el8.template.uiwidget.NewActionsMenu.actions({
                actionsList: actionsList,
                right: false
            }));


        } else {
            this._menuList.append(el8.template.uiwidget.NewActionsMenu.actions({
                actionsList: this._currActionsList
            }));
        }

        // Set position
        var absOffsets = this._computeAbsOffsets($target, offsets);
        this._menuContainer
            .css('top', absOffsets.top)
            .css('left', Math.max(0, absOffsets.left - this._menuContainer.width()))
            .css('z-index', zIndex || 20000);

        this.show();
    };

    el8.uiwidget.NewActionsMenu.prototype._computeAbsOffsets = function($target, offsets) {

        var offsetTop =
            (offsets && offsets.top !== undefined) ?
                offsets.top : this._defaultOffsets.top;
        var offsetLeft =
            (offsets && offsets.left !== undefined) ?
                offsets.left : this._defaultOffsets.left;

        var absOffsetTop = $target.offset().top - this._anchorTop.offset().top + offsetTop;
        var absOffsetLeft = $target.offset().left - this._anchorTop.offset().left + offsetLeft
            + (this._isAlignRight ? $target.width() : 0);

        return {
            top: absOffsetTop,
            left: absOffsetLeft
        };
    };

    el8.uiwidget.NewActionsMenu.prototype.show = function() {
        this._menuContainer.jqmShow();
    };
    el8.uiwidget.NewActionsMenu.prototype.hide = function() {
        this._menuContainer.jqmHide();
    };

    el8.uiwidget.NewActionsMenu.prototype.destroy = function() {
        this._container.off('click', '#'+this._menuId);
        $('#'+this._menuId, this._container).remove();
    };

})();
